import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ErrorService extends BaseService {
    controllerRoute = 'Error';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public async log(data: any): Promise<void> {
        return await firstValueFrom(this.httpClient.post<void>(`${this.apiBaseUrl}/${this.controllerRoute}/Log`, data));
    }
}
